// extracted by mini-css-extract-plugin
export default {"wrapper":"appointment-context_wrapper__fZ5TU"};